import React from "react";
import Banner from "../components/Home//Banner/Banner.jsx";
import AboutUs from "../components/Home/AboutUs/About.jsx";
import Expertise from "../components/Home/Expertise/Expertise.jsx";
import Strength from "../components/Home/Strength/Strength.jsx";
import OurRecords from "../components/Home/Records/Records.jsx";
import Clients from "../components/Home/Client/Client.jsx";

const Home = () => {
  return (
    <div>
      <Banner />
      <AboutUs />
      <Expertise />
      <Strength />
      <OurRecords />
      <Clients />
    </div>
  );
};

export default Home;
